import { makeAutoObservable, runInAction } from 'mobx';
import axios from 'axios';
import appConstants from './constants';


class CallRequestStore {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
    this.productOptions = []
    this.fetched = false;
  }

  async getOptions() {
    if (!this.fetched) {
      try {
        const { data } = await axios.get(appConstants.PRODUCT_LIST, { timeout: 10000 });
        runInAction(() => {
          this.productOptions = Array.isArray(data) ? data : [];
          this.fetched = true;
        });
        return this.productOptions;
      } catch (error) {
        runInAction(() => {
          this.productOptions = [];
          this.fetched = true;
        });
        if (!error.response || error.response.status !== 504) {
          console.error('Cannot get product categories', error);
        }
      }
    }
    return this.productOptions;
  }

  async post(requestData) {
    try {
      await axios.post(appConstants.CALL_REQUEST, requestData);
      return true;
    } catch (error) {
      console.error(error);
    }
  }
}
export default CallRequestStore